import React from 'react'
import Select from 'react-select'


const CustomDropdown = ({
  options,
  placeholder,
  value,
  searchable,
  onSelectOption,
  name = 'custom_dropdown',
  clearable=false
}) => {

  const onChange = (selectedOption, e) => {
    onSelectOption(selectedOption, e)
  }

  return (
    <Select
      name={name}
      options={options}
      placeholder={placeholder}
      value={value}
      isSearchable={searchable}
      onChange={onChange}
      className="product-custom-select"
      isClearable={clearable}
    />
  )
}

export default CustomDropdown